/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProductsJsmFeatureUsageType from '@jira/spa-apps__admin-pages-products-jsm-feature-usage/src/ProductsJsmFeatureUsageType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmFeatureUsage: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ProductsJsmFeatureUsageType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-feature-usage", jiraSpaEntry: "async-products-jsm-feature-usage" */ '@jira/spa-apps__admin-pages-products-jsm-feature-usage/src/ProductsJsmFeatureUsageType.tsx'
		),
	),
);

const AsyncProductsJsmFeatureUsage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmFeatureUsage}
		pageId="products-jsm-feature-usage"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmFeatureUsage;
